import { ChangeDetectionStrategy, Component, OnInit, input } from '@angular/core';
import { Event, NavigationStart, Router } from '@angular/router';
import { Observable, combineLatest } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { AppFacade } from 'ish-core/facades/app.facade';
import { DeviceType, headerTypes } from 'ish-core/models/viewtype/viewtype.types';

@Component({
  selector: 'custom-header',
  templateUrl: './custom-header.component.html',
  styleUrls: ['./custom-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CustomHeaderComponent implements OnInit {
  headerType$: Observable<string>;
  deviceType$: Observable<DeviceType>;
  isSticky$: Observable<boolean>;
  reset$: Observable<Event>;
  wrapperClasses$: Observable<string[]>;
  headerHeight$: Observable<number>;
  animationWrapperClasses$: Observable<string[]>;
  customHeaderWrapperClasses$: Observable<string[]>;
  readonly headerType = input<string>(undefined);
  headerClasses$: Observable<string[]>;
  desktopHeaderHeight$: Observable<string>;

  constructor(private appFacade: AppFacade, private router: Router) {}

  ngOnInit() {
    if (!SSR) {
      this.headerType$ = this.appFacade.headerType$.pipe(
        map(headerType => (headerTypes.includes(headerType) ? headerType : undefined))
      );
    }
    this.deviceType$ = this.appFacade.deviceType$;
    this.isSticky$ = this.appFacade.stickyHeader$;
    this.headerHeight$ = this.appFacade.getDesktopHeaderHeight$;
    this.customHeaderWrapperClasses$ = this.appFacade.customHeaderWrapperClasses$;
    this.animationWrapperClasses$ = this.appFacade.animationWrapperClasses$;
    this.reset$ = this.router.events.pipe(filter(event => event instanceof NavigationStart));

    this.headerClasses$ = combineLatest([this.customHeaderWrapperClasses$, this.animationWrapperClasses$]).pipe(
      map(([customClasses, animationClasses]) => [...customClasses, ...animationClasses])
    );

    this.desktopHeaderHeight$ = combineLatest([this.deviceType$, this.headerHeight$]).pipe(
      map(([deviceType, headerHeight]) => {
        if (deviceType === 'desktop' && headerHeight !== 0) {
          return `${headerHeight}px`;
        } else {
          return 'auto';
        }
      })
    );
  }
}
